import { TimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useState } from 'react';

interface IProps {
  year: number;
  month: string;
}
const THead = ({ year, month }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <thead style={{ background: '#9775fa', color: 'white' }}>
      <tr>
        <th
          colSpan={6}
          style={{ background: 'orange', color: 'black', fontWeight: 'bold' }}
        >
          Pareto Analysis Category Wise {month}-{year}
        </th>
      </tr>
      <tr>
        {[
          'Sr No.',
          'Category',
          'Description',
          'Down Time (Hr.)',
          'Percentage',
          'Cum. Percentage',
        ].map((headingData) => (
          <th>{headingData}</th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
